import {ProviderTypeEnum, StorageKeyEnum} from 'types';
import useLocalStorageState from 'use-local-storage-state';

export const useProviderType = () => {
  const [provider] = useLocalStorageState(StorageKeyEnum.CURRENT_PROVIDER);
  const currentProviderType = provider ?? ProviderTypeEnum.RESTAURANT;

  return {
    providerType: currentProviderType,
    isRestaurant: currentProviderType === ProviderTypeEnum.RESTAURANT,
    queryProviderPrefix: currentProviderType === ProviderTypeEnum.RESTAURANT ? 'restaurants' : 'markets',
  };
};
